import { render, staticRenderFns } from "./MyTextArea.vue?vue&type=template&id=87becaea&"
import script from "./MyTextArea.vue?vue&type=script&lang=js&"
export * from "./MyTextArea.vue?vue&type=script&lang=js&"
import style0 from "./MyTextArea.vue?vue&type=style&index=0&id=87becaea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports